const quadrantTypeOptions = [
	{ value: "CC", label: "Construction Companies" },
	{ value: "CEM", label: "Cement / Particular" },
	{ value: "GC", label: "General Contractors" },
	{ value: "GOV", label: "Government & DOT" },
	{ value: "BP", label: "BePartner" },
];

const notifiableOptions = [
	{ value: "newJob", label: "New Job" },
	{ value: "newLoad", label: "New Load" },
	{ value: "newInvoice", label: "New Invoice" },
	{ value: "newEticket", label: "New Eticket" },
];

const customerTypeOptions = [
	{
		value: "Cement Company",
		label: "Cement Company",
	},
	{
		value: "Constructor",
		label: "Constructor",
	},
	{
		value: "General Contractor",
		label: "General Contractor",
	},
	{
		value: "Incall",
		label: "Incall",
	},
	{
		value: "Optimization",
		label: "Optimization",
	},
	{
		value: "Residential",
		label: "Residential",
	},
	{
		value: "Sub-Contractor",
		label: "Sub-Contractor",
	},
];

const paymentTypeOptions = [
	{
		value: "Credit",
		label: "Credit",
	},
	{
		value: "PrePay",
		label: "PrePay",
	},
	{
		value: "Partial",
		label: "Partial",
	},
];

const paymentTermOptions = [
	{
		value: "30",
		label: "30",
	},
	{
		value: "7",
		label: "7",
	},
	{
		value: "21",
		label: "21",
	},
	{
		value: "Prepayment",
		label: "Prepayment",
	},
	{
		value: "14",
		label: "14",
	},
];

const federalTaxClassificationOptions = [
	{
		value: "C Corporation",
		label: "C Corporation",
	},
	{
		value: "S Corporation",
		label: "S Corporation",
	},
	{
		value: "LLC",
		label: "LLC",
	},
	{
		value: "LLP",
		label: "LLP",
	},
	{
		value: "Partnership",
		label: "Partnership",
	},
	{
		value: "Individual/Sole Proprietor",
		label: "Individual/Sole Proprietor",
	},
	{
		value: "Individual",
		label: "Individual",
	},
	{
		value: "Government",
		label: "Government",
	},
	{
		value: "Non-Profit",
		label: "Non-Profit",
	},
	{
		value: "Trust/Estate",
		label: "Trust/Estate",
	},
];

const franchiseOptions = [
	{
		value: "57Concrete",
		label: "57Concrete",
	},
	{
		value: "Castle",
		label: "Castle",
	},
];

const franchises57Options = [
	{
		value: "57Concrete",
		label: "57Concrete",
	},
	{
		value: "Valley Wide",
		label: "Valley Wide",
	},
];

const franchises57ClientsOptions = [
	{
		value: "57Concrete",
		label: "57Concrete",
	},
	{
		value: "Castle",
		label: "Castle",
	},
	{
		value: "Valley Wide",
		label: "Valley Wide",
	},
];

const rankingOptions = [
	{
		value: "A",
		label: "A",
	},
	{
		value: "B",
		label: "B",
	},
	{
		value: "C",
		label: "C",
	},
	{
		value: "D",
		label: "D",
	},
];

const rankingOptions2 = [
	{
		value: "All",
		label: "All",
	},
	{
		value: "A",
		label: "A",
	},
	{
		value: "B",
		label: "B",
	},
	{
		value: "C",
		label: "C",
	},
	{
		value: "D",
		label: "D",
	},
];

const businessTypeOptions = [
	{ value: "Residential Construction", label: "Residential Construction" },
	{ value: "Commercial Construction", label: "Commercial Construction" },
	{ value: "Industrial Construction", label: "Industrial Construction" },
	{ value: "Municipal/Government", label: "Municipal/Government" },
	{ value: "Concrete Contractor", label: "Concrete Contractor" },
	{ value: "Paving/Roads", label: "Paving/Roads" },
	{ value: "Other", label: "Other" },
];

export {
	quadrantTypeOptions,
	notifiableOptions,
	customerTypeOptions,
	paymentTypeOptions,
	paymentTermOptions,
	franchiseOptions,
	franchises57Options,
	franchises57ClientsOptions,
	rankingOptions,
	rankingOptions2,
	federalTaxClassificationOptions,
	businessTypeOptions,
};
